import React, { Component } from 'react';
import {Chip, Grid, Slider} from "@mui/material";

import Loading from "../loading/Loading";
import Modal from "../../../src/component/modal/ModalTemplate";

import * as apiUtil from "../../util/apiUtil";

import './MessageMosuSelectModal.css';
import button from "bootstrap/js/src/button";

class MessageMapticsSportsSelectModal extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.selectTargetingCategory = this.selectTargetingCategory.bind(this);

        this.handleChangeAge = this.handleChangeAge.bind(this);
        this.handleChangeSex = this.handleChangeSex.bind(this);
        this.handleChangeSportsMainValue = this.handleChangeSportsMainValue.bind(this);
        this.handleChangeSportsMidValue = this.handleChangeSportsMidValue.bind(this);
        this.handleChangeSportsSubValue = this.handleChangeSportsSubValue.bind(this);

        this.ajaxGetStadiumList = this.ajaxGetStadiumList.bind(this);

        this.resetSelectedValue = this.resetSelectedValue.bind(this);
        this.resetValue = this.resetValue.bind(this);
        this.setMapticsData = this.setMapticsData.bind(this);

        this.state = {
            loading: false,

            targetingCategory: "STADIUM",

            ageFrom: 20,
            ageTo: 90,
            sex: 0,

            sportsMain: [{uid: 1, name: "스포츠"}],
            sportsMid: [{uid: 1, name: "야구장"}],
            sportsSub: [],
            sportsMainValue: 1,
            sportsMidValue: 1,
            sportsSubValue: 0,
            sportsMainLabel: "스포츠",
            sportsMidLabel: "야구장",
            sportsSubLabel: "",
        }
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    async selectTargetingCategory(category) {
        await this.setState({ targetingCategory: category });

        switch (category) {
            case "STADIUM":
                this.ajaxGetStadiumList();
                break;
        }
    }

    handleChangeAge(event, value) {
        const { isRemind } = this.props;
        if(isRemind) return;

        this.setState({ ageFrom: value[0], ageTo: value[1] });
    }

    handleChangeSex(value) {
        const { isRemind } = this.props;
        if(isRemind) return;

        this.setState({ sex: value });
    }

    handleChangeSportsMainValue(value) {
        const { isRemind } = this.props;
        if(isRemind) return;

        this.ajaxGetStadiumList();
    }

    handleChangeSportsMidValue(value) {
        this.ajaxGetStadiumList();
    }

    handleChangeSportsSubValue(value) {
        const { isRemind } = this.props;
        if(isRemind) return;

        this.setState({
            sportsSubValue: value.uid,
            sportsSubLabel: value.name,
        });
    }

    ajaxGetStadiumList() {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/maptics/stadium",
            method: apiUtil.requestMethod.POST,
            success: async (result) => {
                this.setState({ sportsSub: result }, () => {
                    const { isRemind, mapticsData } = this.props;
                    if (isRemind && mapticsData) {
                        const stadiumName = this.state.sportsSub.find(s => s.uid === mapticsData.stadiumId)?.name;
                        this.setState({
                            sportsSubValue: mapticsData.stadiumId,
                            sportsSubLabel: stadiumName || "",
                            sex: mapticsData.gender,
                            ageFrom: mapticsData.minAge,
                            ageTo: mapticsData.maxAge,
                            sportsMainLabel: "스포츠",
                            sportsMidLabel: "야구장",
                        });
                    }
                });
            }
        });
    }

    resetValue() {
        this.setState({
            targetingCategory: "STADIUM",

            ageFrom: 20,
            ageTo: 90,
            sex: 0,

            sportsMain: [{uid: 1, name: "스포츠"}],
            sportsMid: [{uid: 1, name: "야구장"}],
            sportsMainValue: 1,
            sportsMidValue: 1,
            sportsSubValue: 0,
            sportsMainLabel: "스포츠",
            sportsMidLabel: "야구장",
            sportsSubLabel: "",
        });
    }

    resetSelectedValue(targetingCategory) {
        switch (targetingCategory) {
            case "AGE":
                this.setState({
                    ageFrom: 20,
                    ageTo: 90,
                });
                break;
            case "SEX":
                this.setState({
                    sex: 0,
                });
                break;
            case "STADIUM":
                this.setState({
                    sportsMain: [],
                    sportsMid: [],
                    sportsSub: [],
                    sportsMainValue: "",
                    sportsMidValue: "",
                    sportsSubValue: "",
                    sportsMainLabel: "",
                    sportsMidLabel: "",
                    sportsSubLabel: "",
                });
                break;
        }
    }

    setMapticsData() {
        const { setMapticsData, handleClose, isRemind } = this.props;
        const { ageTo, ageFrom, sex, sportsSubValue } = this.state;

        if(isRemind) {
            handleClose();
            return;
        }

        if (sportsSubValue === 0) {
            alert("타겟 조건이 선택되지 않았습니다.")
            return;
        }

        setMapticsData({
            gender: sex,
            minAge: ageFrom,
            maxAge: ageTo,
            stadiumId: sportsSubValue,
        });

        handleClose();
    }

    componentDidUpdate(prevProps) {
        const { isOpen, isRemind } = this.props;

        if (!prevProps.isOpen && isOpen) {
            this.ajaxGetStadiumList();
        }

        if(prevProps.isRemind !== this.props.isRemind && !isRemind ) {
            this.resetValue()
        }
    }

    render() {
        const { loading } = this.state;
        const { isOpen, handleClose, isRemind } = this.props;

        const { targetingCategory } = this.state;
        const { selectTargetingCategory } = this;

        const {
            ageFrom, ageTo, sex,
            sportsMainValue, sportsMidValue, sportsSubValue, sportsMainLabel, sportsMidLabel, sportsSubLabel
        } = this.state;
        const {
            handleChangeAge, handleChangeSex,
            handleChangeSportsMainValue, handleChangeSportsMidValue, handleChangeSportsSubValue
        } = this;

        const {
            sportsMain, sportsMid, sportsSub
        } = this.state;


        const { resetSelectedValue, resetValue, setMapticsData } = this;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                className="react-full-modal"
                modalTitle="타겟팅 조건 선택"
                overlayClassName="modal-overlay"
            >
                <Loading loading={loading}/>
                <div id="mosuModal" className='modal-body p-0'>
                    <ul className="mb-0">
                        <li className="p-0 text-light-gray h6">- 조건 미설정 항목은 별도 구분 없이 전체 고객 대상으로 발송됩니다.</li>
                        <li className="p-0 mb-0 text-light-gray h6">- 타겟팅 설정은 대분류 당 하나씩만 가능합니다.</li>
                    </ul>
                    <div className="m-0 p-0 modal-container">
                        <div className="row m-0">
                            <div className="col-4 p-0 columnOverFlow columnLeft">
                                <div
                                    className={targetingCategory === "STADIUM" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("STADIUM")}
                                >
                                    <p className="m-0">스포츠 경기장</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-stadium"
                                        onChange={()=>selectTargetingCategory("STADIUM")}
                                        checked={sportsMainValue > 0 && sportsMidValue > 0 && sportsSubValue > 0}
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "AGE" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("AGE")}
                                >
                                    <p className="m-0">연령</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-age"
                                        onChange={()=>selectTargetingCategory("AGE")}
                                        checked
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "SEX" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("SEX")}
                                >
                                    <p className="m-0">성별</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-sex"
                                        onChange={() => selectTargetingCategory("SEX")}
                                        checked
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-8 p-0">
                                {
                                    targetingCategory === "STADIUM" &&
                                    <div className="h-100 row">
                                        <Grid container spacing={0} colums={12}>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    sportsMain.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeSportsMainValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={sportsMainValue === item.uid}
                                                                onChange={() => handleChangeSportsMainValue(item)}
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow columnRight">
                                                {
                                                    sportsMid.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeSportsMidValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={sportsMidValue === item.uid}
                                                                onChange={() => handleChangeSportsMidValue(item)}
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    sportsSub.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeSportsSubValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={sportsSubValue === item.uid}
                                                                onChange={() => handleChangeSportsSubValue(item)}
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </div>
                                }
                                {
                                    targetingCategory === "AGE" &&
                                    <div className="p-5 h-100">
                                        <Slider
                                            value={[ageFrom, ageTo]}
                                            valueLabelDisplay="auto"
                                            onChange={handleChangeAge}
                                            min={19}
                                            max={90}
                                        />
                                        <div className="d-flex justify-content-between">
                                            <input
                                                className="form-control w-lg-auto d-inline"
                                                value={ageFrom}
                                                readOnly
                                            />
                                            <input
                                                className="form-control w-lg-auto d-inline"
                                                value={ageTo}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    targetingCategory === "SEX" &&
                                    <div className="h-100 row">
                                        <Grid container spacing={0} colums={12}>
                                            <Grid item xs={4} className="columnOverFlow">
                                                <div className="columnRightItem" onClick={() => handleChangeSex(0)}>
                                                    <input
                                                        className='form-check-input'
                                                        type="radio"
                                                        checked={sex === 0}
                                                        onChange={() => handleChangeSex(0)}
                                                    />
                                                    <p className="m-0 ps-2">전체</p>
                                                </div>
                                                <div className="columnRightItem" onClick={() => handleChangeSex(1)}>
                                                    <input
                                                        className='form-check-input'
                                                        type="radio"
                                                        checked={sex === 1}
                                                        onChange={() => handleChangeSex(1)}
                                                    />
                                                    <p className="m-0 ps-2">남성</p>
                                                </div>
                                                <div className="columnRightItem" onClick={() => handleChangeSex(2)}>
                                                    <input
                                                        className='form-check-input'
                                                        type="radio"
                                                        checked={sex === 2}
                                                        onChange={() => handleChangeSex(2)}
                                                    />
                                                    <p className="m-0 ps-2">여성</p>
                                                </div>
                                            </Grid>
                                            <Grid item xs={4} className="columnRight columnOverFlow"></Grid>
                                            <Grid item xs={4} className="columnOverFlow"></Grid>
                                        </Grid>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="p-3 d-flex flex-wrap">
                        {
                            (sportsMainLabel && sportsMidLabel && sportsSubLabel) &&
                            <Chip className="m-1" color="info" variant="outlined" onDelete={! isRemind ? () => resetSelectedValue("STADIUM") : undefined } label={`스포츠 경기장 : ${sportsMainLabel} ${sportsMidLabel ? `> ${sportsMidLabel}` : ""} ${sportsSubLabel ? `> ${sportsSubLabel}` : ""}`}/>
                        }
                        <Chip className="m-1" color="info" variant="outlined" onDelete={! isRemind ? () => resetSelectedValue("AGE") : undefined} label={`연령 : ${ageFrom}세 ~ ${ageTo}세`}/>
                        <Chip className="m-1" color="info" variant="outlined" onDelete={! isRemind ? () => resetSelectedValue("SEX") : undefined} label={`성별 : ${sex === 0 ? "전체" : (sex === 1 ? "남성" : "여성")}`}/>
                    </div>
                </div>
                <div className='modal-footer'>
                    { ! isRemind &&
                        <button className='btn btn-danger btn-md me-2' onClick={resetValue}>선택 초기화</button>
                    }
                    <button className='btn btn-primary btn-md' onClick={setMapticsData}>{! isRemind ? '타겟 설정' : '확인'}</button>
                </div>
            </Modal>
        )
    }
}

MessageMapticsSportsSelectModal.defaultProps = {
    isOpen: false,
    handleClose: function() {},
    setMapticsData: function() {},
}

export default MessageMapticsSportsSelectModal;
